// extracted by mini-css-extract-plugin
module.exports = {"scrollSnap":"tabs_scrollSnap__ay0sm","scrollItem":"tabs_scrollItem__Bk_tj"};